import React, {useContext, useEffect} from "react";
import {STitle} from "shj-components";
import classNames from "classnames";
import {PlusOutlined} from "@ant-design/icons";
import styles from '@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less'
import ChooseTagModal from "@/components/ChooseTagModal";
import {useSetState} from "ahooks";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import {getTagsByClueId} from "@/services/saleOpServices.ts";
import {getTagTreeByType} from "@/services/customerServices.ts";
import {Empty, Spin} from "antd";

const colorList = [
  {
    borderColor: 'rgba(250, 96, 80, 1)',
    fontColor: 'rgba(242, 90, 10, 1)',
  },
  {
    borderColor: 'rgba(0, 100, 255, 1)',
    fontColor: 'rgba(0, 100, 255, 1)',
  },
  {
    borderColor: 'rgba(245, 147, 0, 1)',
    fontColor: 'rgba(245, 147, 0, 1)',
  },
  {
    borderColor: 'rgba(112, 163, 16, 1)',
    fontColor: 'rgba(112, 163, 16, 1)',
  },
]

const Portrait = (props) => {
  const {detailState} = useContext(ClueDetailContext)

  const [state, setState] = useSetState<any>({
    open: false,
    loading: false,
    tags: [], // 详情展示
    tagList: [], // 添加时弹窗
  })

  useEffect(() => {
    detailState.id && getInfo()
    fetchTagTreeByType()
  }, [detailState.id]);

  const getInfo = () => {
    setState({loading: true})
    getTagsByClueId(detailState.id).then(res => {
      let tags = [];
      res.forEach(tag => {
        tags = tags.concat(tag.tags?.map(item => ({...item, key: item.tagId})))
      })
      setState({tags, loading: false})
    })
  }

  // 客户标签
  const fetchTagTreeByType = async () => {
    try {
      const res: any = await getTagTreeByType('custom');
      const obj = {}
      if (res?.records) {
        const tagList: any = [];
        // 一级分类
        res?.records?.forEach(item1 => {
          // 二级
          if (item1?.children && item1?.children?.length) {
            // 第二级为标签
            if(item1?.children?.[0]?.object.groupTag === 'tag' && !obj[item1?.id]){
              obj[item1?.id] = true
              tagList.push({
                key: item1?.id,
                title: item1.label,
                // 二级分类下标签
                tags: item1?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
              })
            }
            item1?.children.forEach(item2 => {
              // 三级分类
              if (item2?.children && item2?.children?.length) {
                  // 第三级为标签
                if(item2?.children?.[0]?.object.groupTag === 'tag' && !obj[item2?.id]){
                  obj[item2?.id] = true
                  tagList.push({
                    key: item2?.id,
                    title: item1.label + ' / ' + item2?.label,
                    // 二级分类下标签
                    tags: item2?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
                  })
                }
                item2?.children.forEach(item3 => {
                  if (item3?.children && item3?.children?.length) {
                    tagList.push({
                      key: item3?.id,
                      title: item1.label + ' / ' + item2?.label + ' / ' + item3?.label,
                      // 三级分类下标签
                      tags: item3?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
                    })
                  }
                })
              }
            })
          }
        });
        setState({tagList});
      }
    } catch (err) {
      console.log(err);
    }
  }

  return <div>
    <div className={classNames([styles.flexBetweenStart, styles.mb20])} style={{alignItems: 'center'}}>
      <STitle title={'画像'}/>
      {detailState.isPublicSea ? null : <PlusOutlined onClick={() => setState({open: true})}/>}
    </div>
    <Spin spinning={state.loading}>
    {(state.tags.length && !state.loading) ?
      <div className={classNames([styles.flexColumnStart, styles.mb10])}>
        <div>
          {state.tags?.map((item, index) => {
            return <span
                key={item.tagId}
                className={styles.mr10}
                style={{
                  display: 'inline-block',
                  padding: '0 5px',
                  marginBottom: 10,
                  borderRadius: 3,
                  border: `1px solid ${colorList[index % 4]?.borderColor}`,
                  color: colorList[index % 4]?.fontColor,
                }}
            >
            {item?.tagName}
          </span>
          })}
        </div>
      </div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </Spin>
    { state.open && <ChooseTagModal reload={() => getInfo()}
                                    tagList={state.tags}
                                    list={state.tagList}
                                    editId={detailState.id}
                                    open={state.open}
                                    onClose={() => setState({open: false})} /> }
  </div>
}

export default Portrait